<!--
  * @Description: 我的网络课程 详情
  * @Author: PF
  * @Date: 2023-08-28 16:01:43.949
 * @LastEditors: PF
 * @LastEditTime: 2025-12-18 16:05:39
-->
<template>
  <div>
    <el-dialog class="w800 h700" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>

      <el-steps :active="stepActive" align-center class="mb10 pl10 pt10 pr10 pm10">
        <el-step title="基本信息" @click="stepActive=0" />
        <el-step title="目录及资源" @click="stepActive=1" />
        <el-step title="相关网络课程" @click="stepActive=2" />
      </el-steps>

      <div style="height: calc(100% - 80px);overflow: auto;">
        <el-descriptions v-if="stepActive===0" :column="2" border>
          <el-descriptions-item label="网络课程名称" label-align="right" align="left" width="120px" span="2">{{ruleForm.wlkcmc}}</el-descriptions-item>
          <el-descriptions-item label="关键字" label-align="right" align="left" span="2">{{ruleForm.gjz}}</el-descriptions-item>
          <el-descriptions-item label="课程" label-align="right" align="left" span="2">{{ruleForm.wljxkcmc}}</el-descriptions-item>
          <el-descriptions-item label="教材" label-align="right" align="left" span="2">{{ruleForm.jcmc}}</el-descriptions-item>
          <el-descriptions-item label="封面图" label-align="right" align="left" span="2">
            <el-image class="avatar" v-if="ruleForm.fmt" style="width: 150px; height: 100px" :src="glj + ruleForm.fmt" fit="cover" />
          </el-descriptions-item>
          <el-descriptions-item label="课程简介" label-align="right" align="left" span="2"><p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.kcjj"></p></el-descriptions-item>
        </el-descriptions>

        <div v-if="stepActive===1">
          <div v-for="(item, index) in treeData" :key="index">
            <span style="height: 26px;line-height: 26px;">{{item.name}}</span>
            <div class="custom-tree-node" v-for="(val, ind) in item.children" :key="ind">
              <span>{{ val.name }}</span>
              <el-button v-if="val.zyid" link type="primary" @click="openZyDetail=true; tcRow={id:val.zyid}">资源名称：{{ val.zymc }}</el-button>
            </div>
          </div>
        </div>

        <el-table v-if="stepActive===2" :data="TableData" border v-loading="loading" height="100%" >
          <el-table-column label="网络课程名称" prop="wlkcmc" align="center" />
          <el-table-column label="网络教学课程名称" prop="wljxkcmc" align="center" />
          <el-table-column label="关键字" prop="gjz" align="center" />
        </el-table>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button v-if="stepActive>0" type="primary" @click="stepActive=stepActive-1">上一步</el-button>
            <el-button v-if="stepActive<2" type="primary" @click="stepActive=stepActive+1">下一步</el-button>
            <el-button v-if="stepActive==2" type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <detail v-if="openZyDetail" v-model:openDetail="openZyDetail" :row="tcRow" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadSelect, actionPost, closeWindow } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo'
import detail from '@/components/ziyuan/detail.vue'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])

const glj = ref(process.env.VUE_APP_BASE_API) // 根路径
const stepActive = ref(0)

const ruleForm = ref({})
const treeData = ref([])
const TableData = ref([])

const tcRow = ref({})
const openZyDetail = ref(false)
const loading = ref(false)
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      actionPost({
        url: '/api/v2/wangluojiaoxue/wangluokecheng/' + props.row.id,
        data: {}
      }).then((res) => {
        if (res.code === 200) {
          ruleForm.value = res.data
          loadSelect({ url: '/api/v2/wangluojiaoxue/wangluokecheng/chaxunmuluziyuan', parms: { id: ruleForm.value.id }, data: treeData })
          loadSelect({ url: '/api/v2/wangluojiaoxue/wangluokecheng/list', parms: { order: 'wlkcmc', sort: 'asc', inIDs: ruleForm.value.listXgwlkcid }, data: TableData })
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
.custom-tree-node {
  width: 100%;
  height: 26px;
  line-height: 26px;
  padding-left: 20px;
  display: flex;
  justify-content: space-between;
}
.custom-tree-node:hover {
  background-color: #ecf5ff;
}
</style>
